export const isApiMocked = !import.meta.env.VITE_API_BASE_URL
export const isAuthMocked = !import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (import.meta.env.PROD) {
  if (isApiMocked) {
    throw new Error('VITE_API_BASE_URL is required in production')
  }
  if (isAuthMocked) {
    throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required in production')
  }
}

// --- Observability (fail-open — see docs/notes/telemetry-fails-open.md) ---
export const appEnvironment = import.meta.env.VITE_APP_ENVIRONMENT || import.meta.env.MODE

const rawSentryDsn = import.meta.env.VITE_SENTRY_DSN ?? ''
export const sentryDsn = rawSentryDsn.startsWith('RUNTIME_') ? '' : rawSentryDsn
export const isSentryEnabled = !!sentryDsn

if (import.meta.env.PROD && !isSentryEnabled) {
  console.warn('[observability] VITE_SENTRY_DSN is not set — running without error tracking')
}

const rawPosthogKey = import.meta.env.VITE_POSTHOG_KEY ?? ''
export const posthogKey = rawPosthogKey.startsWith('RUNTIME_') ? '' : rawPosthogKey
export const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'
export const isPosthogEnabled = !!posthogKey

if (import.meta.env.PROD && !isPosthogEnabled) {
  console.warn('[observability] VITE_POSTHOG_KEY is not set — running without feature analytics')
}

declare const __APP_VERSION__: string
declare const __BUILD_ID__: string

export const appVersion: string = __APP_VERSION__
export const buildId: string = __BUILD_ID__
